import './preloader.css'

const Preloader = () => {
    return <div className={`window_preloader`}>
        <div className="lds-roller">
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
            <div/>
        </div>
    </div>
}


export default Preloader;

